/**
 *
 * Roihilmi - Timetec Maintenance
 * Define all global functions in here. It will wrap up with mix webpack inside public/core.js
 * Don't forget to run npm run dev/prod once done or just set npm run watch
 */

 getFilenameLength = function(filename) {
    let arrFile = filename.split('.');

    var name = arrFile[0];
    var extension = arrFile[1];
    var length = name.length;

    if (length > 25) {
        return name.substr(0,0) +'...'+ name.substr(-10) +'.'+ extension;
    }

    return filename;
}

$(function($){
    var ktooltips = document.querySelectorAll(".tooltipL");
    ktooltips.forEach(function(ktooltip, index){                // For each ktooltip
    ktooltip.addEventListener("mouseover", position_tooltip); // On hover, launch the function below
    })

    function position_tooltip(){
    // Get .ktooltiptext sibling
    var tooltip = this.parentNode.querySelector(".tooltipLtext");

    // Get calculated ktooltip coordinates and size
    var ktooltip_rect = this.getBoundingClientRect();

    var tipX = ktooltip_rect.width + 5; // 5px on the right of the ktooltip
    var tipY = 20;                     // 40px on the top of the ktooltip
    // Position tooltip
    tooltip.style.top = tipY + 'px';
    tooltip.style.left = tipX + 'px';

    // Get calculated tooltip coordinates and size
    var tooltip_rect = tooltip.getBoundingClientRect();
    // Corrections if out of window
    if ((tooltip_rect.x + tooltip_rect.width) > window.innerWidth) // Out on the right
        tipX = -tooltip_rect.width + 42;  // Simulate a "right: tipX" position
    if (tooltip_rect.y < 0)            // Out on the top
        tipY = tipY - tooltip_rect.y;    // Align on the top

    // Apply corrected position
    tooltip.style.top = tipY + 'px';
    tooltip.style.left = tipX + 'px';
}
});
